module.exports = __webpack_public_path__ + "img/8.597498fb.jpg";